import { render, staticRenderFns } from "./showPayTable.vue?vue&type=template&id=63fdc7fc&scoped=true&"
import script from "./showPayTable.vue?vue&type=script&lang=js&"
export * from "./showPayTable.vue?vue&type=script&lang=js&"
import style0 from "./showPayTable.vue?vue&type=style&index=0&id=63fdc7fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fdc7fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63fdc7fc')) {
      api.createRecord('63fdc7fc', component.options)
    } else {
      api.reload('63fdc7fc', component.options)
    }
    module.hot.accept("./showPayTable.vue?vue&type=template&id=63fdc7fc&scoped=true&", function () {
      api.rerender('63fdc7fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpOpsManager/components/showPayTable.vue"
export default component.exports